import { render, staticRenderFns } from "./DropdownNationalHubsLayout.vue?vue&type=template&id=8ecdbb06&scoped=true&"
import script from "./DropdownNationalHubsLayout.vue?vue&type=script&lang=ts&"
export * from "./DropdownNationalHubsLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownNationalHubsLayout.vue?vue&type=style&index=0&id=8ecdbb06&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecdbb06",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixLink: require('/root/project/frontend/src/components/BixLink.vue').default})
